var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyBirthdayStripesBerisfordsFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "381px",
    height: "1961px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 381 1960",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .str5 {stroke:#4BB74A;stroke-width:0.899693}\n    .str1 {stroke:#7955A3;stroke-width:0.899693}\n    .str2 {stroke:#EE264F;stroke-width:0.899693}\n    .str3 {stroke:#F0533B;stroke-width:0.899693}\n    .str4 {stroke:#F5E46C;stroke-width:0.899693}\n    .str0 {stroke:black;stroke-width:8.85525}\n    .fil12 {fill:none}\n    .fil9 {fill:#4BB74A}\n    .fil8 {fill:#4BB74A}\n    .fil3 {fill:#4C85C5}\n    .fil1 {fill:#7955A3}\n    .fil4 {fill:#7955A3}\n    .fil2 {fill:#EE264F}\n    .fil5 {fill:#EE264F}\n    .fil11 {fill:#F0533B}\n    .fil6 {fill:#F0533B}\n    .fil10 {fill:#F5E46C}\n    .fil7 {fill:#F5E46C}\n    .fil0 {fill:white}\n   \n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_835861664"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0 str0",
    points: "9,12 372,12 372,1948 192,1771 9,1948 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil1",
    x: 9,
    y: 53,
    width: 362.186,
    height: 40.1509
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    x: 9,
    y: 12,
    width: 362.186,
    height: 43.288
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1728,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1461,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1194,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 927,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 660,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 393,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 126,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1728,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1461,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 1194,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 927,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 660,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 393,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 11,
    y: 126,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 1684,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 1417,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 1150,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 883,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 616,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 349,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4 str1",
    x: 11,
    y: 82,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 1639,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 1372,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 1105,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 838,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 571,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 304,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil5 str2",
    x: 11,
    y: 37,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 1595,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 1328,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 1061,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 794,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 527,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 260,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil6 str3",
    x: 11,
    y: 13,
    width: 359.666,
    height: 23.7722
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 1550,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 1283,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 1016,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 749,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 482,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil7 str4",
    x: 11,
    y: 215,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 1506,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 1239,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 972,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 705,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 438,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil8 str5",
    x: 11,
    y: 171,
    width: 359.666,
    height: 44.5041
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "10,1771 190,1771 145,1816 10,1816 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    points: "10,1814 146,1814 101,1859 10,1859 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil11",
    points: "9,1858 103,1858 58,1902 9,1902 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "8,1899 61,1899 16,1943 8,1943 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil9",
    points: "371,1771 189,1771 234,1816 371,1816 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil10",
    points: "373,1814 234,1814 279,1859 373,1859 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil11",
    points: "373,1858 278,1858 323,1902 373,1902 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil5",
    points: "373,1899 319,1899 364,1943 373,1943 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M196 146l77 -1c2,-3 3,-5 2,-9 -4,-4 -5,-4 -12,-4 -6,0 -11,0 -16,1l-48 2 1 -14 66 0c3,-1 5,-2 8,-3l-1 -1c1,-6 -1,-6 -5,-8 -9,-1 -29,0 -39,0 -14,1 -27,0 -41,0 -17,1 -64,-4 -74,6 0,7 4,8 12,8 21,0 39,-2 62,-1l-2 12c-23,0 -51,-3 -72,4 -1,8 1,11 11,10 8,0 16,0 24,0 15,-1 31,-2 47,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M235 682l1 0 37 0c2,-4 4,-6 1,-11 -9,-7 -59,2 -75,-1l1 -11c1,-1 0,-2 8,-1l31 0c12,0 27,2 34,-5 0,-11 -10,-8 -22,-8 -12,1 -86,2 -90,0 -13,3 -43,-4 -47,8l2 4c11,3 22,2 35,1 13,0 25,0 37,0l-1 8 0 4 -7 0 -46 1c-10,0 -12,0 -20,4l0 5 1 2c2,1 4,3 8,3l-1 0 113 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M254 726c-2,3 -9,5 -14,6l-4 1c-4,2 -15,3 -19,3 -2,1 -6,1 -10,1 -18,1 -34,0 -51,-1 -12,-3 -25,-4 -28,-14 8,0 24,-2 30,0l7 -1c1,0 4,0 5,0 24,-1 69,-3 88,-1 -1,4 -1,4 -4,6zm-13 18c6,-2 12,-6 18,-8 2,-2 6,-5 8,-8 4,-3 3,-6 6,-10l0 -2 0 -5c0,-1 -1,-1 -1,-1 0,-1 -2,-3 -4,-4 -3,-1 -5,-1 -8,-1 -20,1 -32,2 -56,2 -25,0 -52,-1 -77,0l-8 1c-5,1 -5,1 -7,4l0 5c0,9 0,9 5,15l3 3c4,2 6,4 12,7 20,7 30,7 53,7 20,0 38,2 56,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M186 445c-2,7 -21,7 -30,7 -12,1 -23,0 -28,-8l58 1zm75 1c-6,7 -51,7 -55,-1 12,0 46,-1 55,1zm-80 17c5,-1 7,-2 12,-4 6,-3 4,-1 11,1 9,3 18,3 27,4 15,0 20,-1 33,-6 6,-3 9,-6 12,-13 1,-5 1,-7 -1,-11 -12,-3 -25,0 -39,-1 -14,0 -27,0 -40,0 -22,-1 -63,-4 -82,-1 -3,5 -3,4 -2,11 0,2 1,3 2,5 1,3 1,1 1,4 3,2 4,3 8,5 2,2 5,3 8,4 19,4 29,5 50,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M166 198l-1 0 -5 1 1 -5c1,-3 1,-4 3,-7l25 2 41 6c-21,2 -43,3 -64,3zm-10 15c5,-3 16,-2 22,-3l16 -1c4,0 9,-1 13,0l41 -4 25 -2c3,-5 3,-8 2,-14l-4 -1 -10 -1 0 -1 -15 0 -36 -4 -40 -6 -26 -4 -12 -2c-12,-2 -13,-5 -19,3 -1,3 0,4 1,6 5,2 9,2 15,4l23 2 -2 10 -1 3c-1,3 -3,3 -7,3 -3,0 -6,1 -9,1 -8,0 -13,-1 -19,2 -2,3 -3,5 -2,10l4 2c14,2 28,-5 40,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M160 800l3 -12c8,-1 60,6 66,8l-69 4zm-21 15l6 -1c14,-2 26,-2 40,-3 14,-1 28,-3 42,-3l22 -2 6 0c2,-1 7,-1 11,-1 6,0 5,-1 8,-2l1 -4c0,-5 1,-6 -1,-10 -2,0 -1,1 -3,0 -2,0 -2,-1 -2,-1l-16 -1c-5,0 -16,1 -20,-2l-3 0 -43 -5c-14,-2 -63,-12 -71,-10 -2,2 -4,4 -2,9 3,5 28,6 37,8 0,3 0,9 -2,11l-1 4 -31 2 -4 1c-1,4 -2,7 0,11 12,1 14,0 26,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M262 553c-3,12 -41,5 -51,0l51 0zm-106 16c3,-2 26,-4 32,-5 11,-2 12,-4 27,4 0,0 1,0 1,0l1 1c4,0 11,2 17,2 6,0 12,0 18,0l9 -2c3,-3 5,-3 8,-7 3,-2 4,-5 5,-9 1,-5 2,-8 -3,-10 -1,-2 3,0 -1,-1 -3,-1 -1,-1 -4,-1l-38 0c-9,0 -34,2 -42,1 -4,2 -17,1 -23,1 -4,2 -19,1 -25,1 -5,0 -9,0 -14,-1 -9,0 -6,0 -13,3l1 7c16,3 15,0 36,0 11,-1 31,-2 41,0 -7,0 -30,4 -39,6 -15,2 -25,4 -37,9 -6,6 -2,11 6,10 11,-2 25,-9 37,-9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M255 248c-1,10 -18,8 -27,8 -24,-1 -24,-6 -28,-7l55 -1zm-3 19c6,-2 8,-2 13,-5 2,-2 4,-3 6,-6l1 -8 0 -6 -3 -5c-3,0 -1,0 -2,-1l0 0c-7,-1 -20,1 -28,1l-9 0 -3 0c-7,0 -21,0 -27,-2 -6,0 -11,1 -17,1 -5,0 -11,0 -16,0l-39 0c-10,1 -18,0 -19,8 1,1 1,2 2,3 0,1 1,1 1,1l1 2 74 -1 2 6 4 4c1,0 0,-1 2,1 3,2 4,4 9,6 4,1 9,1 12,2 14,1 23,1 36,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M256 302c-2,10 -18,8 -28,8 -9,-1 -24,-1 -27,-7l55 -1zm12 12c1,-2 0,1 2,-3 1,-1 0,0 1,-1l1 -3 0 -13c-3,-4 -7,-5 -14,-4 -7,1 -47,2 -50,0 -4,0 -5,1 -8,-1 -7,0 -17,1 -24,0 -8,0 -15,0 -23,0 -10,0 -37,-1 -42,4 -7,13 12,11 23,10 12,0 24,0 37,0 9,0 13,-2 16,1 4,3 4,8 9,11 5,4 10,5 17,6 7,2 23,2 31,1 4,0 9,-1 13,-2 6,-2 7,-4 11,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M255 846c3,-2 4,-2 8,-3 3,-1 5,-3 7,-4l0 -2 0 -3 -1 -1c-5,-2 -1,-2 -9,-2l-31 8c-1,1 -7,2 -9,2l-18 6c-15,3 -58,3 -75,2 -10,-1 -18,-3 -16,8 8,5 13,4 24,4 9,0 19,0 28,0 41,0 37,-1 75,6 5,1 20,3 23,5l3 -1c6,0 8,0 10,-4 0,-8 -13,-9 -21,-11 -8,-1 -20,-3 -27,-4l29 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M274 376c0,-6 -3,-7 -8,-9 -13,-4 -33,-5 -39,-7 8,-5 39,-5 44,-16l-3 -3c-4,-4 -6,-2 -12,-1 -10,3 -22,5 -33,8 -13,4 -20,7 -36,8 -14,1 -27,2 -42,2 -25,-1 -36,-6 -34,7 6,4 8,4 16,4l62 0c31,0 38,5 63,9l9 2c3,-1 5,-1 9,0 1,-2 2,-3 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M154 508l9 0 34 -1 10 0 11 1 42 0c-1,6 0,8 2,12 5,2 8,2 11,-3l0 -29 -1 -5c-3,-1 -6,-1 -10,-1 -4,4 -4,5 -3,11l-1 1c-2,2 1,1 -5,1 -1,0 -4,0 -6,1l-33 -1c-14,0 -28,0 -42,0 -13,0 -28,1 -42,1l0 -5c-2,-2 -5,-3 -11,-3l-3 4 0 8c0,10 -3,25 12,21 5,-3 3,-8 4,-13l22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M272 616c1,-9 2,-18 2,-27 -2,-1 -1,0 -2,-2l-1 0c-12,-1 -11,5 -13,14 -42,1 -84,4 -126,5 -7,0 -11,-1 -15,2l-2 0 0 5c3,4 4,5 12,5 7,0 14,-1 20,0 4,-2 29,-3 35,-1 1,-1 1,-1 2,-1 1,0 2,-1 3,-1 3,0 5,0 7,0l2 1c2,-2 7,-1 11,-1l51 -3 -1 4 1 8c2,0 4,4 9,2 5,-1 5,-5 5,-10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M189 985l77 -1c2,-4 4,-5 2,-10 -4,-4 -5,-4 -12,-4 -5,0 -11,1 -16,1l-47 2 0 -14 66 1c4,-2 6,-3 8,-4l-1 -1c1,-6 0,-6 -5,-8 -9,-1 -29,0 -39,1 -14,0 -27,-1 -40,-1 -18,1 -64,-4 -74,6 0,7 3,8 12,8 20,0 38,-2 62,-1l-3 12c-23,0 -51,-2 -71,4 -2,8 1,11 11,11 7,-1 15,-1 23,-1 16,0 31,-1 47,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M228 1520l1 0 38 0c1,-4 3,-6 1,-10 -9,-8 -59,1 -76,-1l1 -12c1,-1 0,-1 8,-1l31 0c13,0 28,3 35,-4 -1,-12 -11,-9 -23,-8 -12,0 -85,1 -90,-1 -12,3 -43,-4 -46,8l1 4c11,4 23,2 35,2 13,-1 25,-1 38,-1l-2 8 0 5 -6 -1 -46 1c-11,1 -12,0 -21,4l0 6 1 1c3,2 4,3 8,3l0 0 112 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M247 1564c-2,4 -9,6 -14,7l-4 1c-4,1 -14,2 -19,2 -2,1 -6,1 -9,1 -18,1 -34,0 -52,-1 -11,-2 -25,-4 -28,-14 8,0 24,-2 30,0l7 -1c2,0 4,0 6,0 24,-1 68,-3 88,0 -1,3 -2,3 -5,5zm-13 18c7,-2 12,-6 18,-8 2,-2 6,-5 9,-8 3,-3 3,-6 5,-9l0 -3 0 -5c0,0 0,0 0,-1 0,0 -2,-3 -5,-3 -3,-2 -5,-1 -8,-1 -20,0 -32,2 -56,1 -25,0 -52,-1 -77,1l-7 0c-5,1 -5,1 -7,5l-1 4c0,9 0,10 6,15l3 3c4,2 6,5 11,7 20,7 31,8 54,8 20,0 37,1 55,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M179 1283c-2,7 -21,7 -29,8 -13,0 -24,-1 -29,-9l58 1zm76 2c-7,6 -52,6 -56,-2 12,0 47,-1 56,2zm-81 16c5,-1 8,-1 12,-3 6,-3 5,-2 11,0 9,3 18,4 27,4 15,0 21,-1 33,-6 7,-3 9,-6 13,-13 0,-5 1,-7 -2,-11 -12,-3 -25,0 -39,0 -13,-1 -27,-1 -40,-1 -22,0 -63,-4 -82,0 -3,4 -3,3 -2,10 1,2 1,3 2,5 1,3 1,2 2,4 3,2 4,4 8,6 2,1 5,2 7,3 20,4 29,5 50,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M159 1037l-1 0 -4 0 0 -5c1,-3 1,-4 3,-7l26 2 40 6c-21,2 -42,3 -64,4zm-9 14c4,-3 15,-2 21,-2l16 -1c4,-1 9,-2 13,-1l42 -4 25 -2c2,-5 2,-7 2,-14l-5 -1 -10 -1 0 0 -15 -1 -36 -4 -40 -6 -25 -4 -13 -2c-11,-2 -13,-5 -19,3 0,3 0,4 1,6 6,3 9,3 16,4l22 2 -2 10 0 3c-2,3 -4,3 -8,3 -3,1 -6,1 -9,1 -8,1 -13,0 -19,2 -2,3 -2,5 -2,10l4 2c14,2 28,-5 41,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M153 1638l3 -12c8,0 61,6 67,9l-70 3zm-21 15l6 0c14,-3 27,-3 41,-4 13,-1 27,-2 41,-3l23 -2 5 0c3,-1 7,-1 11,-1 6,0 5,-1 8,-2l1 -4c1,-4 1,-6 0,-9 -3,0 -1,0 -4,-1 -1,0 -1,-1 -2,-1l-15 -1c-6,0 -16,1 -20,-2l-4 0 -43 -5c-14,-2 -62,-12 -71,-10 -2,2 -4,4 -2,9 4,6 28,6 37,8 1,3 0,9 -2,11l-1 4 -30 2 -4 1c-2,5 -3,7 -1,11 12,1 15,0 26,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M255 1391c-3,12 -41,5 -50,0l50 0zm-106 17c3,-3 26,-5 32,-6 11,-2 12,-3 27,4 0,0 1,0 1,0l2 1c4,0 10,2 16,2 6,0 13,0 19,0l8 -1c3,-4 5,-4 9,-8 2,-2 3,-5 4,-9 1,-5 2,-8 -3,-10 -1,-1 3,1 -1,-1 -2,-1 -1,0 -4,-1l-37 0c-10,1 -35,3 -42,1 -5,2 -18,2 -24,1 -4,2 -19,1 -25,1 -4,0 -9,0 -13,0 -10,-1 -7,0 -13,2l0 8c17,2 16,0 36,-1 11,-1 31,-2 41,0 -6,0 -30,5 -39,6 -15,2 -25,4 -37,9 -6,7 -2,11 6,10 11,-2 26,-9 37,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M249 1087c-1,10 -18,7 -28,7 -24,-1 -23,-5 -27,-7l55 0zm-3 18c5,-2 8,-2 13,-5 2,-2 3,-3 5,-6l1 -8 0 -6 -2 -5c-4,0 -2,1 -3,-1l0 1c-7,-1 -20,0 -28,0l-9 0 -3 0c-7,0 -21,1 -27,-1 -6,-1 -10,0 -17,0 -5,0 -11,0 -16,0l-39 0c-10,1 -18,0 -19,9 1,0 2,2 2,2 1,1 1,2 1,2l1 1 74 -1 3 6 3 4c1,0 0,-1 2,2 4,1 5,3 10,5 3,1 8,2 12,2 13,1 23,1 36,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M249 1141c-2,9 -17,7 -28,7 -9,0 -23,-1 -27,-7l55 0zm13 12c0,-2 -1,0 1,-3 1,-2 0,-1 1,-2l2 -3 -1 -13c-3,-4 -7,-4 -14,-4 -7,1 -46,2 -50,0 -3,0 -5,1 -8,-1 -6,0 -16,1 -24,1 -7,0 -15,0 -22,0 -10,0 -37,-2 -43,3 -7,13 12,11 23,11 12,-1 25,-1 37,-1 9,0 14,-2 16,1 4,4 5,8 10,12 4,3 10,5 16,6 7,1 24,1 31,0 5,0 9,-1 13,-2 6,-2 8,-4 12,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M248 1684c3,-2 5,-2 8,-3 3,-1 5,-3 8,-4l0 -1 0 -4 -1 -1c-5,-1 -2,-2 -9,-2l-32 8c-1,1 -6,2 -9,2l-17 6c-16,3 -58,4 -76,2 -10,0 -17,-3 -16,8 9,5 13,5 24,5 9,0 19,0 28,0 41,0 38,-2 76,6 4,1 19,2 22,4l3 0c6,0 8,-1 10,-5 0,-8 -13,-9 -21,-10 -8,-2 -19,-4 -27,-5l29 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M267 1214c0,-6 -2,-7 -8,-8 -13,-4 -33,-6 -39,-8 9,-5 40,-5 44,-16l-3 -3c-4,-3 -6,-2 -12,-1 -9,3 -22,6 -33,9 -13,3 -20,7 -35,7 -15,1 -28,2 -43,2 -24,0 -36,-6 -34,7 6,4 8,4 17,4l62 0c31,0 37,5 62,9l9 2c4,-1 5,-1 9,0 1,-1 3,-3 4,-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M148 1346l8 0 34 -1 11 1 11 0 41 0c0,6 0,8 2,12 6,2 8,2 11,-2l1 -30 -2 -4c-3,-1 -6,-2 -10,-1 -4,3 -3,4 -3,10l0 1c-3,2 0,1 -5,1 -2,1 -5,1 -6,1l-34 -1c-13,0 -27,0 -41,0 -14,0 -29,1 -42,1l0 -5c-3,-2 -6,-3 -12,-3l-3 4 0 8c0,11 -3,26 13,22 4,-4 2,-9 3,-14l23 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M265 1454c1,-9 2,-18 2,-27 -2,-1 -1,0 -2,-2l-1 0c-12,-1 -11,6 -12,14 -43,1 -85,4 -127,5 -7,0 -11,-1 -15,2l-1 1 -1 4c3,4 4,6 13,5 6,0 13,-1 19,1 4,-2 30,-3 35,-2 1,-1 1,-1 3,-1 0,0 2,0 3,0 2,-1 4,-1 6,-1l2 1c3,-2 7,-1 11,-1l51 -3 -1 4 1 8c2,1 5,4 10,2 4,-1 4,-5 4,-10z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil12 str0",
    points: "9,12 372,12 372,1948 192,1771 9,1948 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyBirthdayStripesBerisfordsFinal);
export default __webpack_public_path__ + "static/media/happy-birthday-stripes-berisfords-final.59273d5e815fcda45539866efec6e2aa.svg";
export { ForwardRef as ReactComponent };